import { render, staticRenderFns } from "./EditTaskItemTable.vue?vue&type=template&id=f0212560&scoped=true"
import script from "./EditTaskItemTable.vue?vue&type=script&lang=js"
export * from "./EditTaskItemTable.vue?vue&type=script&lang=js"
import style0 from "./EditTaskItemTable.vue?vue&type=style&index=0&id=f0212560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0212560",
  null
  
)

export default component.exports